import React, { useState, useEffect } from 'react';
import { createAndResizeRectImgDivs } from '../scripts/resizer';
import frequentIcon from "../assets/images/1_Intro/intro_pivotal_face1.jpg";
import reliableIcon from "../assets/images/1_Intro/intro_pivotal_face6.jpg";
import accessibleIcon from "../assets/images/1_Intro/intro_pivotal_face3.jpg";
import climateIcon from "../assets/images/1_Intro/intro_pivotal_face4.jpg";
import arrowIcon from "../assets/images/icon-arrow-blue.png"; // Ensure the arrow icon is correctly imported

const defaultImages = [
    <img className= "rect-img" src={frequentIcon} alt="" aria-hidden="true" />, 
    <img className= "rect-img" src={reliableIcon} alt="" aria-hidden="true" />, 
    <img className= "rect-img" src={accessibleIcon} alt="" aria-hidden="true" />, 
    <img className= "rect-img" src={climateIcon} alt="" aria-hidden="true" />
];
const defaultCaptions = [
    <p><strong>More frequent.</strong> We will deliver <strong>more frequent subway, bus, and commuter rail service.</strong></p>,
    <p><strong>More reliable.</strong> Customer journey time and on-time performance will <strong>exceed 90%.</strong></p>,
    <p><strong>More accessible.</strong> <strong>95% of all commuter rail and subway stations</strong> will become accessible by 2045 and 2055, respectively.</p>,
    <p><strong>More climate-ready.</strong> Greenhouse gas <strong>emissions will be reduced by 85% and vulnerable infrastructure will be protected against extreme weather</strong>.</p>,
];

const defaultStyle = "image-slideshow ss-blue"; // Default style for the carousel

const ImageCarousel = ({images, captions, styleClasses, label, customIcon}) => {
    // Use default images and captions if none are provided
    images = images || defaultImages;
    const text = captions || defaultCaptions;
    const style = styleClasses || defaultStyle; 
    const arrow = customIcon || arrowIcon; // Use custom icon if provided, otherwise use default
    
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        createAndResizeRectImgDivs(); // Call the function to resize images
        setFade(true);
    }, [currentIndex]);

    const nextSlide = () => {
        setFade(false);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setFade(false);
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    return (
        <div className={style} role="region" aria-label={label} aria-roledescription="carousel">
            <button className="slideshow-trigger" aria-label="Stop automatic slide show">
                <i className="fa fa-pause"></i><span>Stop automatic slide show</span>
            </button>
            <button className="slideshow-move prev" aria-label="Previous Slide" onClick={prevSlide}>
                <img src={arrow} alt="" aria-hidden="true" /><span>Previous Slide</span>
            </button>
            <button className="slideshow-move next" aria-label="Next Slide" onClick={nextSlide}>
                <img src={arrow} alt="" aria-hidden="true" /><span>Next Slide</span>
            </button>
            <div className="image-slideshow-slides" aria-live="off">
                {images.map((image, index) => (
                    <div key={index} className={`${index === currentIndex ? 'active' : ''} ${fade ? 'fadeIn' : ''}`} role="group" aria-roledescription="slide">
                        {image}
                        {text[index]}
                    </div>
                ))}
            </div>
            <ul>
                {images.map((_, index) => (
                    <li key={index} className={index === currentIndex ? 'active' : ''}>
                        <button onClick={() => setCurrentIndex(index)} aria-label={`Slide ${index + 1}`}></button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ImageCarousel;